"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _hexToRgb = _interopRequireDefault(require("../utils/hexToRgb"));

var styles = function styles(_ref) {
  var theme = _ref.theme,
      type = _ref.type;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;align-items:left;padding:14px 16px 14px;font-size:14px;line-height:17px;font-weight:500;.Icon{margin-right:10px;}", type === 'warning' && "\n    background-color: rgba(".concat((0, _hexToRgb.default)(theme.color.yellowHover), ", 0.2);\n    color: ").concat(theme.color.yellow, ";\n    fill: ").concat(theme.color.yellow, ";\n  "))
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1b68o3y0"
})(styles));

exports.default = _default;